// extracted by mini-css-extract-plugin
export var button = "_d4-4";
export var hasDarkBackground = "_d4-7";
export var hasLightBackground = "_d4-6";
export var iconWrapper = "_d4-0";
export var large = "_d4-2";
export var medium = "_d4-1";
export var small = "_d4-5";
export var xsmall = "_d4-3";